<app-auth-navbar></app-auth-navbar>
    
    <!-- <p *ngIf="auth.user">Hii! {{auth.user.name}} , Please verify your email</p>

    <button (click)="resendVerifyLink()">Resend Email Verification Link</button> -->
    <div class="container" style="min-height:100vh">
        <div class="row">
            <div class="col-md-4 col-12 mx-auto" style="margin-top: 150px;">
                    <h3 class="custom-heading text-center">Verify your email address</h3>
                    
                    <p class="text-center">We have sent a verification email to {{auth.user.email}} </p>

                    <p class="text-center">Please click the verification link in that email to secure your account.</p>

                    <button (click)="resendVerifyLink()" class="btn primary-btn signin__btn w-100 button_figma">Resend Email Verification Link</button>
            </div>
        </div>
    </div>